export default __webpack_public_path__ + "static/GT-America-Condensed-Black-336ee57b38a24e48536d5e9787415333.woff2";